import { render, staticRenderFns } from "./LearnerStatusCellRenderer.vue?vue&type=template&id=724cdc5d&"
import script from "./LearnerStatusCellRenderer.vue?vue&type=script&lang=js&"
export * from "./LearnerStatusCellRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports